/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';
import { ThemesType } from 'src/models/theme-setup';

export const SI_GET_ALL_THEMES_REQUEST = 'SI_GET_ALL_THEMES_REQUEST';
type SI_GET_ALL_THEMES_REQUEST_TYPE = 'SI_GET_ALL_THEMES_REQUEST';

export const SI_GET_ALL_THEMES_SUCCESS = 'SI_GET_ALL_THEMES_SUCCESS';
type SI_GET_ALL_THEMES_SUCCESS_TYPE = 'SI_GET_ALL_THEMES_SUCCESS';

export const SI_GET_ALL_THEMES_FAILURE = 'SI_GET_ALL_THEMES_FAILURE';
type SI_GET_ALL_THEMES_FAILURE_TYPE = 'SI_GET_ALL_THEMES_FAILURE';

type SIThemeFailure = {
  error: any
};

type SIGetAllThemesRequestAction = Action<SI_GET_ALL_THEMES_REQUEST_TYPE, null>;

type SIGetAllThemesSuccessAction = Action<SI_GET_ALL_THEMES_SUCCESS_TYPE, { data: ThemesType }>;

type SIGetAllThemesFailureAction = Action<SI_GET_ALL_THEMES_FAILURE_TYPE, SIThemeFailure>;

export type SIThemeAction =
  | SIGetAllThemesRequestAction
  | SIGetAllThemesSuccessAction
  | SIGetAllThemesFailureAction;

export type SIThemeState = {
  getAllThemesLoading: boolean,
  allThemes: ThemesType | []
};
